<template>
  <div id="Customers">
    <v-container fluid>
      <v-tabs background-color="white" class="elevation-0" v-model="tab">
          <v-tab :href="`#tab-${index}`" :key="index" v-for="(tab,index) in tabs">
            <v-icon class="mr-3" size="18">{{ tab.icon }}</v-icon>
            {{ tab.name }}
          </v-tab>
          <v-tab-item :key="index" :value="`tab-${index}`" v-for="(tab,index) in tabs">
            <template v-if="tab.id===1 && organizations">
              <v-row>
                <v-col class="mt-1" cols="8">
                  <v-card-title>
                    <span class="text-h6">Customers ({{ organizations.length }})</span>
                  </v-card-title>
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="mr-3 d-flex mt-1" cols="3">
                  <v-text-field clearable dense label="Search" outlined v-model="search"></v-text-field>
                  <v-btn @click="startCreateCustomer" color="primary" elevation="0" class="ml-2">
                    ADD CUSTOMER
                  </v-btn>
                </v-col>
                <v-col class="px-8" cols="12">
                  <v-data-table fixed-header @click:row="openCustomerDetail" height="calc(100vh - 320px)" :headers="headers" :items="organizations"
                                :footer-props="{itemsPerPageOptions:[25,50,100]}" :items-per-page="25" :search="search"
                                class="elevation-0">
                    <template v-slot:no-data>No Customers Available</template>
                    <template v-slot:no-results>No Customers Available</template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name ? item.name : '-' }}
                    </template>
                    <template v-slot:item.mobile="{ item }">
                      {{ item.mobile ? item.mobile : '-' }}
                    </template>
                    <template v-slot:item.whatsappNumber="{ item }">
                      {{ item.whatsappNumber ? item.whatsappNumber : '-' }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      {{ item.status ? item.status : '-' }}
                    </template>
                    <template v-slot:item.gstInNumber="{ item }">
                      {{ item.gstInNumber ? item.gstInNumber : '-' }}
                    </template>
                    <template v-slot:item.totalDueAmount="{ item }">
                      {{ item.totalDueAmount ? `₹ ${item.totalDueAmount}` : '-' }}
                    </template>
                    <template v-slot:item.type="{ item }">
                      {{ item.Type ? item.Type.type : '-' }}
                    </template>
                    <template v-slot:item.address="{ item }">
                      <template v-if="item.Address">
                        <div><span v-if="item.Address.area">{{ item.Address.area }},</span></div>
                        <div>{{ item.Address.city }}, {{ item.Address.state }},
                          {{ item.Address.country }}
                        </div>
                      </template>
                      <template v-else>-</template>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn small @click.stop="editOrganization(item)" icon>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </template>
            <template v-if="tab.id===2 && organizations">
              <GmapMap :center="{lat:21.1702,lng:72.8311}" :options="options" :zoom="12"
                       style="width: 100%; height: 80vh">
                <gmap-info-window :opened="infoWinOpen" :options="infoOptions" :position="infoWindowPos"
                                  @closeclick="infoWinOpen=false">
                </gmap-info-window>
                <GmapMarker :clickable="true" :key="index" :label="org.name" :position="org.position"
                            :title="org.name" @click="toggleInfoWindow(org,index)"
                            v-for="(org,index) in gmapObjects"/>
              </GmapMap>
            </template>
          </v-tab-item>
        </v-tabs>
    </v-container>
    <CreateUpdateOrganization :org="org" :saveOrganizationDialog="saveOrganizationDialog"
                              @saveOrganization="saveOrganization" @cancel="cancelSaveOrganization"
                              v-if="saveOrganizationDialog"></CreateUpdateOrganization>
    <OrganizationDetail @saveOrganization="saveOrganization" @cancel="organizationDetailDialog=false"
                        :organizationDetailDialog="organizationDetailDialog" v-if="organizationDetailDialog"
                        :organizationId="org.id"></OrganizationDetail>
  </div>
</template>

<script>
import { SUBSCRIBE_ALL_CUSTOMERS } from '../../graphql/subscriptions/Organizations'
import CreateUpdateOrganization from '../../components/OrganizationManagement/CreateUpdateOrganization'
import OrganizationDetail from '../../components/OrganizationManagement/OrganizationDetail'

export default {
  name: 'Customers',
  components: { OrganizationDetail, CreateUpdateOrganization },
  data () {
    return {
      search: '', organizations: [], gmapObjects: [], organizationDetailDialog: false,
      infoWindowPos: null, infoWinOpen: false, currentMidx: null, saveOrganizationDialog: false,
      infoOptions: { content: '', pixelOffset: { width: 0, height: -35 } },
      org: null, tab: '',
      tabs: [
        { id: 1, icon: 'mdi-account-group', name: 'Customer List' },
        { id: 2, icon: 'mdi-truck-delivery', name: 'Customer Map' },
      ],
      headers: [
        { text: 'Name', value: 'name' }, { text: 'Mobile', value: 'mobile' },
        { text: 'Whatsapp', value: 'whatsappNumber' }, { text: 'Status', value: 'status' },
        { text: 'Type', value: 'type' }, { text: 'GSTIN', value: 'gstInNumber' },
        { text: 'Total Due Amount', value: 'totalDueAmount', width: 130 },
        { text: 'Address', value: 'address' }, { text: 'Action', value: 'actions' },
      ],
      options: {
        zoomControl: true, mapTypeControl: true, scaleControl: true,
        streetViewControl: false, rotateControl: false, fullscreenControl: true,
        disableDefaultUI: false,
      },
    }
  },
  apollo: {
    $subscribe: {
      Organizations: {
        query: SUBSCRIBE_ALL_CUSTOMERS, fetchPolicy: 'network-only',
        variables () { return { orgId: JSON.parse(localStorage.user).organization.id } },
        result ({ data, loading }) {
          if (!loading) {
            this.gmapObjects = [];
            this.organizations = [];
            let organizationIds = [];
            data.RouteShops.forEach(shop => {
              if(!organizationIds.includes(shop.Organization.id)) {
                this.organizations.push(shop.Organization);
                organizationIds.push(shop.Organization.id)
              }
            });
            this.organizations.forEach(org => {
              this.gmapObjects.push({
                infoText: `<strong>${org.name} (${org.Type.type})</strong><br/>
                                                        <stong>${org.mobile}</stong>`,
                position: { lat: parseFloat(org.lat), lng: parseFloat(org.long) },
              })
            })
          }
        },
      },
    },
  },
  methods: {
    startCreateCustomer () {
      this.org = null
      this.saveOrganizationDialog = true
    },
    editOrganization (obj) {
      this.org = obj
      this.saveOrganizationDialog = true
    },
    openCustomerDetail (customer) {
      this.org = customer
      this.organizationDetailDialog = true
    },
    cancelSaveOrganization () {
      this.saveOrganizationDialog = false
      this.org = null
    },
    saveOrganization () {
      this.saveOrganizationDialog = false
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoOptions.content = marker.infoText

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true
        this.currentMidx = idx

      }
    },
  },
}
</script>

<style scoped>
/*https://github.com/xkjyeah/vue-google-maps/blob/vue2/examples/infowindow.html*/
/deep/ tr {
  cursor: pointer;
}
</style>
